import styles from "./Loader.module.scss";

const Loader = ({ customStyles, height = "100vh" }) => {
  return (
    <div style={{ height: height }} // Set height dynamically
      className={`${styles.loaderWrapper} ${customStyles && styles.customStyles
        }`}
    >
      <div className={styles.loader}></div>
    </div>
  );
};

export default Loader;
